module.exports = __webpack_public_path__ + "static/img/home-service1.1b78e411.png";